var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", { staticClass: "left" }, [
      Object.keys(_vm.amazonLinkingInfo).length
        ? _c("div", { class: _vm.amazonLinkingInfo.classes }, [
            _c("span", [
              _vm._v(_vm._s(_vm.amazonLinkingInfo.amazonLinkingStatus))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n      " + _vm._s(_vm.amazonLinkingInfo.subTitle) + "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.userInfo.hasSpAccount && _vm.userInfo.enableFlag
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "form-group flexbox" }, [
              _c(
                "label",
                {
                  staticClass:
                    "control-label flex-item flex-lable flexbox justify-between seller-id-label"
                },
                [_vm._v("\n          出品者ID\n        ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex-item flex-input" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("amazonMerchantId"),
                        expression: "errors.has('amazonMerchantId')"
                      }
                    ],
                    staticClass: "text-danger",
                    staticStyle: { display: "block" }
                  },
                  [_vm._v("※" + _vm._s(_vm.errors.first("amazonMerchantId")))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|max:20",
                      expression: "'required|max:20'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.amazonMerchantId,
                      expression: "data.amazonMerchantId"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    "data-vv-name": "amazonMerchantId",
                    "data-vv-as": "出品者ID",
                    disabled: _vm.hasMerchantId
                  },
                  domProps: { value: _vm.data.amazonMerchantId },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.data,
                        "amazonMerchantId",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mr-b-30 mr-t-50" }, [
        _c("div", { staticClass: "text--underline" }, [
          _vm._v("「Amazonと連携」ボタンについて")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "pd-l-10 m-b-lg" }, [
          _vm._v(
            "セールモンスターとご利用中のセラーセントラルアカウントを連携します。"
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "m-b" }, [
          _vm._v("※詳しい手順は"),
          _c(
            "a",
            {
              staticClass: "text--underline",
              attrs: { href: _vm.downloadUrl, download: "", target: "_blank" }
            },
            [_vm._v("こちら")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-center box-btn-link-amazon" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-warning w-254 btn-link-amazon",
            on: { click: _vm.updateAmazonInfo }
          },
          [_vm._v("Amazonと連携")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mr-b-10" }, [
      _vm._v(
        "\n        セールモンスターは、このアカウントを使用してAmazonとデータ連携を行います。"
      ),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "pd-l-10 m-b-lg" }, [
      _vm._v("\n        「Amazonと連携」ボタンをクリックすると、"),
      _c("br"),
      _vm._v(
        "\n        Amazonセラーセントラルの「セールモンスターを承認」画面に移動します。"
      ),
      _c("br"),
      _vm._v(
        "\n        画面に表示された内容を確認し、セールモンスターのアクセス許可を承認していただくと、連携完了です。\n      "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1a6af8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1a6af8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAmazon/AmazonInfo.vue
// module id = null
// module chunks = 